export default __webpack_public_path__ + "content/media/20.d2b0ae00.jpg";